import BaseDataService from "./BaseDataService";

class ClientDataService extends BaseDataService {
  constructor(name) {
    super(name)
    this.moduleName = 'clients'
  }
}

export default new ClientDataService();